import { ProfileModel, ProfileModelOptions } from './ProfileModel';
import { EditProfileRequest, MeResponse, ProfileResource } from '@foxbun/lib-goferal-types';
import { action, observable } from 'mobx';

export type MyProfileModelOptions = ProfileModelOptions<ProfileResource> & {
  logout: () => any;
};

export class MyProfileModel extends ProfileModel<MeResponse> {
  private promise_me: Promise<void>;

  @observable
  public accessor loaded: boolean;

  constructor(protected options2: MyProfileModelOptions) {
    super(options2);
    this.loaded = false;
  }

  get isMe(): boolean {
    return true;
  }

  @action
  async refresh(): Promise<void> {
    if (!this.promise_me) {
      this.promise_me = this.options.api_client.profile
        .me()
        .then((res) => {
          this.setData(res);
          this.options.id = res._id;
        })
        .catch((ex) => {
          this.options2.logout();
          throw ex;
        })
        .finally(() => {
          this.promise_me = null;
          this.loaded = true;
        });
    }
    return this.promise_me;
  }

  isFriend(model: ProfileModel) {
    return false;
  }

  async editProfile(params: EditProfileRequest) {
    await this.options2.api_client.profile.editProfile(params);
    await this.refresh();
  }
}
